/* eslint eqeqeq: "off" */
import * as React from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import './Bling.css';
import { Card, Carousel } from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';

import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { addAcceptedBlingQuote, acceptBlingCover, setIsOnQuoteScreen } from '../../../actions/salesActions';


class Covers extends React.PureComponent<any, any> {
    Carousel: any;
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            submitted: false,
            loggedIn: this.props.auth.uid ? true : false,
            activeIndex: 1,
            dotIndex: 1,
            productNames: ['Brand-new', 'Like-new', 'Screen-fix'],
            productColors: ['brand-new-colour', 'like-new-colour', 'screen-fix-colour']
        };
        this.onSlideChanged = this.onSlideChanged.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.selectCoverOption = this.selectCoverOption.bind(this);
        this.Carousel = React.createRef();
    }

     handleClick(e: any) {
         let value = e.target.value;
         this.Carousel.slideTo(value);
         this.setState({
            activeIndex: value,
            dotIndex: value
        })
        this.forceUpdate();
    }

    onSlideChanged(e) {
        this.Carousel.slideTo(e.item);
         this.setState({
            activeIndex: e.item,
            dotIndex: e.item
        })
        this.forceUpdate();
    }

    async selectCoverOption(e : any) {
        this.props.dispatchSetIsOnQuoteScreen(false, "", "");
        var riskItemId;
        if (e.target?.id) {
            riskItemId = this.props.sales.blingPremiums.blingQuotes?.find(x => x.description === e.target.id).riskItemId;
        }
        else {
            riskItemId = this.props.sales.blingPremiums.blingQuotes?.find(x => x.description === this.state.productNames[this.state.activeIndex]).riskItemId;
        }
        await this.props.dispatchAcceptBlingCover(riskItemId);
        return e;
    }

    public render() {
        const responsive = {
            0: { items: 1 },
            568: { items: 1 },
            750: { items: 2 },
            1024: { items: 2 },
            1100: { items: 3 },
        };
        
        const items = [
            <div data-value="1" className="item">
                <Card className="content-box-padding-20px-with-box-shadow mb-15px bling-cover-brand-new text-left">
                    <p className="bling-covers-p mb-5px">{this.props.sales.blingPremiums.blingQuotes?.find(x => x.description === "Brand-new")?.description}</p>
                    <p className="bling-premium-title">Total monthly premium</p>
                    <p className="bling-premium">{this.props.profile.currencySymbol}{this.props.sales.blingPremiums.blingQuotes?.find(x => x.description === "Brand-new").premium.toFixed(2)}</p>
                    <hr className="hr-brand-new" />
                    <div className="row noma justify-content-center">
                        <div className="col-12 nopa bling-get-it-button-holder">
                            <button onClick={this.selectCoverOption} className="btn btn-block btn-outline-white button-width cursor-pointer" id="Brand-new">Get it</button>
                        </div>
                    </div>
                </Card>
                <Card className="content-box-padding-20px-with-box-shadow text-left">
                    <div className="bling-cover-options-nutshell-p-holder">
                        <p className="bling-cover-nutshell">In a nutshell</p>
                        <p className="font-weight-normal mb-0px bling-cover-options-nutshell-p">Brand-new cover means we’ll repair your damaged phone if we can or replace it with a brand-spanking-new phone if we need to, following theft, loss, accidental damage or water damage.</p>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-with-p-holder">
                        <p className="bling-cover-nutshell mb-0px">A brand-new phone</p>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-worldwide-p-holder">
                        <p className="bling-cover-nutshell">Worldwide cover for</p>
                        <ul className="bling-cover-options-cover-options">
                            <li className="font-weight-normal">Loss</li>
                            <li className="font-weight-normal">Theft</li>
                            <li className="font-weight-normal">Water damage</li>
                            <li className="font-weight-normal">Accidental damage</li>
                        </ul>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-warranty-p-holder">
                        <p className="bling-cover-nutshell">Warranty</p>
                        <p className="mb-0px font-weight-300">Manufacturer’s warranty</p>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-excess-p-holder">
                        <p className="bling-cover-nutshell">Excess</p>
                        <p className="mb-0px font-weight-normal line-height-normal">5% of the claim value with a minimum of R300<br /><br />OR<br /><br /> 15% of the claim value with a maximum of R4,500</p>
                    </div>
                </Card>
            </div>,
            <div data-value="2" className="item">
                <Card className="content-box-padding-20px-with-box-shadow mb-15px bling-cover-like-new text-left">
                    <p className="bling-covers-p mb-5px">Like-new</p>
                    <p className="bling-premium-title">Total monthly premium</p>
                    <p className="bling-premium">{this.props.profile.currencySymbol}{this.props.sales.blingPremiums.blingQuotes?.find(x => x.description === "Like-new").premium.toFixed(2)}</p>
                    <hr className="hr-like-new" />
                    <div className="row noma justify-content-center">
                        <div className="col-12 nopa bling-get-it-button-holder">
                            <button type="submit" onClick={this.selectCoverOption} className="btn btn-block btn-outline-white button-width cursor-pointer" id="Like-new">Get it</button>
                        </div>
                    </div>
                </Card>
                <Card className="content-box-padding-20px-with-box-shadow text-left">
                    <div className="bling-cover-options-nutshell-p-holder">
                        <p className="bling-cover-nutshell">In a nutshell</p>
                        <p className="font-weight-normal mb-0px">Like-new cover means we’ll repair your damaged phone if we can, or replace it if we need to, following theft, loss, accidental damage or water damage. Replacement will be with a similar make and model or a similar, refurbished phone.</p>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-with-p-holder">
                        <p className="bling-cover-nutshell">A like-new phone with</p>
                        <ul className="bling-cover-options-cover-options-1">
                            <li className="font-weight-normal">The manufacturer’s original motherboard</li>
                            <li className="font-weight-normal mb-0px">A new battery, screen and casing</li>
                        </ul>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-worldwide-p-holder">
                        <p className="bling-cover-nutshell">Worldwide cover for</p>
                        <ul className="bling-cover-options-cover-options">
                            <li className="font-weight-normal">Loss</li>
                            <li className="font-weight-normal">Theft</li>
                            <li className="font-weight-normal">Water damage</li>
                            <li className="font-weight-normal">Accidental damage</li>
                        </ul>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-warranty-p-holder">
                        <p className="bling-cover-nutshell">Warranty</p>
                        <p className="mb-0px font-weight-normal">12-month warranty, provided that you haven’t claimed for water/liquid damage</p>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-excess-p-holder">
                        <p className="bling-cover-nutshell">Excess</p>
                        <p className="mb-0px font-weight-normal line-height-normal">5% of the claim value with a minimum of R300<br /><br />OR<br /><br /> 15% of the claim value with a maximum of R4,500</p>
                    </div>
                </Card>
            </div>,
            <div data-value="3" className="item">
                <Card className="content-box-padding-20px-with-box-shadow mb-15px bling-cover-screen-fix text-left">
                    <p className="bling-covers-p mb-5px">{this.props.sales.blingPremiums.blingQuotes?.find(x => x.description === "Screen-fix").description}</p>
                    <p className="bling-premium-title">Total monthly premium</p>
                    <p className="bling-premium">{this.props.profile.currencySymbol}{this.props.sales.blingPremiums.blingQuotes?.find(x => x.description === "Screen-fix").premium.toFixed(2)}</p>
                    <hr className="hr-screen-fix" />
                    <div className="row noma justify-content-center">
                        <div className="col-12 nopa bling-get-it-button-holder">
                            <button onClick={this.selectCoverOption} type="submit" className="btn btn-block btn-outline-white button-width cursor-pointer" id="Screen-fix">Get it</button>
                        </div>
                    </div>
                </Card>
                <Card className="content-box-padding-20px-with-box-shadow text-left">
                    <div className="bling-cover-options-nutshell-p-holder">
                        <p className="bling-cover-nutshell">In a nutshell</p>
                        <p className="font-weight-normal mb-0px">Screen-fix cover is only for cracks to your phone’s screen due to accidental damage.</p>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-with-p-holder">
                        <p className="bling-cover-nutshell">No replacement, only screen repair</p>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-worldwide-p-holder">
                        <p className="bling-cover-nutshell">Worldwide cover for</p>
                        <ul className="bling-cover-options-cover-options">
                            <p className="line-height-normal font-weight-normal mb-15px">Cracks due to:</p>
                            <li className="font-weight-normal">Bumping</li>
                            <li className="font-weight-normal">Dropping</li>
                        </ul>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-warranty-p-holder">
                        <p className="bling-cover-nutshell">Warranty</p>
                        <p className="mb-0px font-weight-normal">12-month warranty on all screen repairs</p>
                    </div>
                    <hr className="bling-cover-options-hr-2px" />
                    <div className="bling-cover-options-excess-p-holder">
                        <p className="bling-cover-nutshell mb-10px">Excess</p>
                        <p className="mb-0px font-weight-normal line-height-normal">R250 per claim</p>
                    </div>
                </Card>
            </div>,
        ];

        let dotIndexValue = this.state.dotIndex

        return (
            <div className="col-12 nopa" id="Covers">
                <div className="alice-carousel mb-30px mt-0px">
                    <ul className="alice-carousel__dots mt-0px">
                        <li className={dotIndexValue === 0 ? "alice-carousel__dots-item __active" : "alice-carousel__dots-item"} value={0} onClick={this.handleClick}></li>
                        <li className={dotIndexValue === 1 ? "alice-carousel__dots-item __active" : "alice-carousel__dots-item"} value={1} onClick={this.handleClick}></li>
                        <li className={dotIndexValue === 2 ? "alice-carousel__dots-item __active " : "alice-carousel__dots-item "} value={2} onClick={this.handleClick}></li>
                    </ul>
                </div>
                <AliceCarousel
                    animationType="fadeout"
                    animationDuration={800}
                    mouseTracking={true}
                    items={items}
                    responsive={responsive}
                    disableButtonsControls
                    touchTracking={true}
                    activeIndex={this.state.activeIndex}
                    onSlideChanged={this.onSlideChanged}
                    ref={el => this.Carousel = el}
                />
                <div className="row ml-0 d-block d-sm-none d-md-none d-lg-none acceptButton" onClick={this.selectCoverOption} >
                    <div className={this.state.productColors[this.state.activeIndex] + " coverOptionsMobile col-12"}>
                        <p className="mb-0px mt-15px font-weight-bold">Get bling {this.state.productNames[this.state.activeIndex]} cellphone cover for</p>
                        <p className="mb-15px mt-12px font-size-30px font-weight-800">{this.props.profile.currencySymbol}{this.props.sales.blingPremiums.blingQuotes?.find(x => x.description === this.state.productNames[this.state.activeIndex]).premium.toFixed(2)} pm</p>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        cart: state.cart,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchRedirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetBlingCover: (item) => dispatch(addAcceptedBlingQuote(item)),
        dispatchAcceptBlingCover: (item) => dispatch(acceptBlingCover(item)),
        dispatchSetIsOnQuoteScreen: (flag, itemId, itemDescription) => dispatch(setIsOnQuoteScreen(flag, itemId, itemDescription)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Covers);